var Vendd = (function (Vendd) {
    'use strict';

    var pending = {};
    var fetched = {};

    Vendd.MessageBus.subscribe(Vendd.ProjectAgora.Messages.GetBanner, Vendd.ProjectAgora, function (envelope) {
        var data = envelope.message.data;
        var widgetId = data.widgetId;

        if (widgetId ===  undefined || widgetId === '') {
            return;
        }
        if (fetched[widgetId] !== undefined) {
            Vendd.MessageBus.publishAsync(Vendd.ProjectAgora, new Vendd.ProjectAgora.Messages.GetBannerSuccess(widgetId, fetched[widgetId]));
            return;
        }
        if (pending[widgetId] !== undefined) {
            return;
        }

        pending[widgetId] = true;

        function onSuccess(response) {
            fetched[widgetId] = response;
            delete pending[widgetId];
            Vendd.MessageBus.publishAsync(Vendd.ProjectAgora, new Vendd.ProjectAgora.Messages.GetBannerSuccess(widgetId, response));
        };

        function onFailure(response) {
            delete pending[widgetId];
            Vendd.MessageBus.publishAsync(Vendd.ProjectAgora, new Vendd.ProjectAgora.Messages.GetBannerFailure(widgetId, response));
        };

        var options = {
            url: 'ProjectAgoraService.svc/GetBanner',
            data: data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };
        Vendd.Service.call(options);

        return;
    });

    return Vendd;

})(Vendd || {});